export const getStatus = ({ isSubscriber, isCharterMember }:{ isSubscriber?: boolean, isCharterMember?: boolean }) => {
  if (isCharterMember) return ' -- SPECIAL CHARTER MEMBER PRICE';
  if (isSubscriber) return ' -- SPECIAL SUBSCRIBER PRICE';
  if (isCharterMember && isSubscriber) return ' -- SPECIAL CHARTER MEMBER PRICE';
  return null;
};
